import React from "react";
import ContactForm from "../Contact/ContactForm";
import { NavLink } from "react-router-dom";

const FormWithBackGroundImage = ({ heading, subHeading, btnText, dataLayout }) => {
  return (
    <div className={"home section_2_wrapper  club__form"}>
      <div className="club__form__wrapper">
        <h1 className="home__section1-txt1 text-jost-sb-50-wt">{heading}</h1>

        <h3 className="home__section1-txt1 text-jost-sb-22-wt">{subHeading}</h3>

        <div className="club__form__wrapper__button">
          <NavLink to ="/club-detail">
          <button className="res-btn-primary">{btnText}</button></NavLink>
        </div>

        <div className="club__form__wrapper__form">
          {dataLayout }
        </div>
      </div>
    </div>
  );
};

export default FormWithBackGroundImage;
